module.exports = __webpack_public_path__ + "static/img/youli-2.909702c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/youli-2.png
// module id = 175
// module chunks = 1